<div class="power-by-tabit-bottom">
    <div class="inner-wrapper">
        <div class="no-wrap">Powered By</div>
        <div style="width:0.25rem"></div>
        <img src="../../../assets/images/tabit_logo_allgreen.png" />
    </div>
</div>
